
import { v4 as uuid } from 'uuid';
import { Component, Emit, Model, Prop, Vue } from 'nuxt-property-decorator';
import { ActionRadioGroupOption } from '../../types';
import InputRadio from '../design-system/input/input-radio/InputRadio.vue';

@Component({ components: { InputRadio } })
export default class ActionRadioGroup extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly options!: ActionRadioGroupOption[];
  @Prop({ type: String, required: true }) readonly groupId!: string;
  @Prop({ type: String, default: null }) readonly labelId!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  @Model('change', { type: String, default: null }) readonly value!: string;

  uniqueId = uuid();

  @Emit('change') emitChange(value: string) {
    return value;
  }

  get innerValue() {
    return this.value;
  }

  set innerValue(value: string) {
    this.emitChange(value);
  }

  public itemClasses(option: ActionRadioGroupOption) {
    return { '-active': this.innerValue === option.id, '-disabled': this.disabled };
  }
}
